import React from 'react';

import { useHistory } from 'react-router-dom';

import { ConflictModalContent } from '../OwnerInfo/components/ConflictModalContent';

import { Routes } from '../../../../../../constants';

export const OwnerExists = () => {
  const {
    push,
    location,
  } = useHistory();

  return (
    <ConflictModalContent
      signInCtaProps={{
        target: '_parent',
        href: Routes.Login,
      }}
      onCancelClick={() => {
        push({
          pathname: Routes.SignupBasicInfo,
          search: location.search,
        });
      }}
    />
  );
};
